import Vue from 'vue'
import App from './App.vue'
import i18n from './message'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import BaseLayout from '@/layout/BaseLayout.vue'
import SimpleLayout from '@/layout/SimpleLayout.vue'
import SimpleLogoutLayout from '@/layout/SimpleLogoutLayout.vue'
import moment from 'moment'

Vue.config.productionTip = false

// レイアウト定義
Vue.component('base-layout', BaseLayout)
Vue.component('simple-layout', SimpleLayout)
Vue.component('simpleLogout-layout', SimpleLogoutLayout)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  i18n
}).$mount('#app')

// グローバルフィルタ
Vue.filter('addComma', (val) => {
  return val.toLocaleString()
})

Vue.filter('dateFormatter', (date) => {
  return date ? moment(date).format('YYYY/MM/DD HH:mm') : ''
})
